import { Chip } from '@material-ui/core';
import React from 'react';

export const VerifyNow = ({ status, handleVerify }) => {
    const isVerified = status === 'VERIFIED';
    return (
        <div className="d-flex flex-direction-column">
            <Chip
                size="small"
                variant="outlined"
                label={isVerified ? 'VERIFIED' : 'Verify Now'}
                color={isVerified ? 'primary' : 'secondary'}
                onClick={() => !isVerified && handleVerify()}
                clickable
            />
        </div>
    );
};